<template>
  
  <div class="app-popup">



  </div>

</template>

<script>
export default{

  data: function(){

    return {
      
    }

  }

}
</script>

<style scoped>

</style>
